import "./App.css";
import { useEffect } from "react";
import { Route, Routes  } from "react-router-dom";
import SubmitContent from "./client/pages/SubmitContent/SubmitContent";
import QuestionsSelection from "./client/pages/QuestionsSelection/QuestionsSelection";
import Question from "./client/pages/Question/Question";
import Layout from "./client/layout/Layout";
import MissingPage from "./client/components/Error/MissingPage";
import RequireAuth from "./client/auth/RequireAuth";
import SignupPage from "../../client/src/client/pages/signup/SignupPage";
import LoginPage from "../../client/src/client/pages/login/LoginPage.jsx";
import AccountInformation from "./client/pages/AccountInformation/AccountInformation";
import useCanvasDetection from "./client/hooks/useCanvasDetection";
import ChangePassword from "./client/pages/AccountInformation/ChangePassword";
import ForgetPassword from "./client/pages/ForgetPassword/ForgetPassword";
import ResetPassword from "./client/pages/ResetPassword/ResetPassword";
import HistoryPage from "./client/pages/History/HistoryPage";
import ConfirmFileUploadModal from "./client/components/modals/ConfirmFileUploadModal.jsx";
import AutoLogouthook from "./client/hooks/autoLogouthook.js";
import useDisableBrowserNavigation from "./client/hooks/useDisableBrowserNavigation.js"; 
import ThankyouPage from "./client/pages/ThankyouPage/ThankyouPage.jsx";
import CancelPage from "./client/pages/CancelPage/CancelPage.jsx";
import WelcomePage from "./client/pages/Welcome/Welcome.jsx";

function App() {
  // Detect if the user's device supports canvas rendering
  const isCanvas = useCanvasDetection();

  useEffect(() => {
    // Check if the URL contains a "source" parameter
    const url = new URL(window.location.href);
    if (url.searchParams.has("source")) {
      // Set a session storage flag for canvas support
      sessionStorage.setItem("canvas", "true");
      // Set a session storage flag for Quillionz 2.0
      sessionStorage.setItem("qz2.0", "true");
    } else {
      // If no "source" parameter is found, set canvas support flag to false
      sessionStorage.setItem("canvas", "false");
      // Remove the Quillionz 2.0 flag
      sessionStorage.removeItem("qz2.0");
    }
  }, []);

  useDisableBrowserNavigation();
  return (
    <AutoLogouthook>
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Public Routes */}
        <Route exact path="/signup" element={<SignupPage />} />
        <Route exact path="/welcome" element={<WelcomePage />} />
        <Route exact path="/forgetpassword" element={<ForgetPassword />} />
        <Route exact path="/resetpassword" element={<ResetPassword />} />
        <Route exact path="/thankyou" element={<ThankyouPage />} />
        <Route exact path="/CancelPage" element={<CancelPage />} />
        {/* Display different pages based on the 'isCanvas' flag */}
        <Route path="/" element={ isCanvas ? <SubmitContent hasCanvas={isCanvas} /> : <LoginPage />}/>
        <Route path="/pagenotfound" element={<MissingPage />} />

        {/* Protected Routes */}
        <Route element={<RequireAuth />}>
          <Route exact path="/jjj" element={<ConfirmFileUploadModal />} />
          <Route exact path="/submitcontent" element={<SubmitContent />} />
          <Route exact path="/QuestionsSelection" element={<QuestionsSelection />} />
          <Route exact path="/question" element={<Question />} />
          <Route exact path="/history" element={<HistoryPage />} />
          <Route exact path="/userinfo" element={<AccountInformation />} />
          <Route exact path="/changepassword" element={<ChangePassword />} />
        </Route>
      </Route>
      {/* Catch All  */}
      <Route exact path="*" element={<MissingPage />} />
    </Routes>
    </AutoLogouthook>
  );
}

export default App;
